module.exports = __webpack_public_path__ + "static/media/undraw_profile_pic.edef4671.svg";